export const FooterLinks = () => (
  // TODO: unify this with FooterAccordion to keep these in sync more easily
  <div className="footer__link-block">
    <ul className="footer__link-column">
      <li className="label2" data-qa-id="footer_aboutus">
        About Us
      </li>
      <li>
        <a className="list1" href="/pages/about-us" data-qa-id="footer_story">
          Our story
        </a>
      </li>
      <li>
        <a className="list1" href="/blog/" data-qa-id="footer_blog">
          Blog
        </a>
      </li>
      <li>
        <a className="list1" href="/pages/press/" data-qa-id="footer_press">
          Press
        </a>
      </li>
      <li>
        <a className="list1" href="/pages/careers/" data-qa-id="footer_careers">
          Careers
        </a>
      </li>
      <li>
        <a className="list1" href="/pages/donation/" data-qa-id="footer_giving">
          Giving back
        </a>
      </li>
    </ul>

    <ul className="footer__link-column">
      <li className="label2" data-qa-id="footer_explore">
        Explore
      </li>

      <li>
        <a className="list1" href="/invites/" data-qa-id="footer_invitations">
          Invitations
        </a>
      </li>
      <li>
        <a className="list1" href="/signup-sheets/" data-qa-id="footer_sus">
          SignUp Sheets
        </a>
      </li>
      <li>
        <a className="list1" href="/cards/featured" data-qa-id="footer_ecards">
          Greeting Cards
        </a>
      </li>
      <li>
        <a className="list1" href="/egift-cards/" data-qa-id="footer_egift_cards">
          eGift Cards
        </a>
      </li>
      <li>
        <a className="list1" href="/content/site_map" data-qa-id="footer_site_map">
          Site map
        </a>
      </li>
    </ul>

    <ul className="footer__link-column">
      <li className="label2" data-qa-id="footer_myevite">
        My Evite
      </li>
      <li>
        <a className="list1" href="/settings/account" data-qa-id="footer_account">
          My Account
        </a>
      </li>
      <li>
        <a className="list1" href="/my-events/" data-qa-id="footer_myevents">
          My Invitations
        </a>
      </li>
      <li>
        <a
          className="list1"
          href="/my-events/?type=signup-sheets&offset=0&status=all"
          data-qa-id="footer_mysheets"
        >
          My SignUp Sheets
        </a>
      </li>
      <li>
        <a
          className="list1"
          href="/my-events/?type=card&offset=0&status=all"
          data-qa-id="footer_myecards"
        >
          My eCards
        </a>
      </li>
      <li>
        <a className="list1" href="/login" data-qa-id="footer_signin">
          Sign In
        </a>
      </li>
    </ul>

    <ul className="footer__link-column">
      <li className="label2" data-qa-id="footer_help">
        Get Help
      </li>
      <li>
        <a className="list1" href="https://support.evite.com/" data-qa-id="footer_faqs">
          FAQs
        </a>
      </li>
      <li>
        <a
          className="list1"
          href="https://www.evite.com/pages/support-ticket/"
          data-qa-id="footer_contact"
        >
          Contact us
        </a>
      </li>
      <li>
        <a
          className="list1"
          href="https://support.evite.com/support/solutions/articles/72000576133-invitation-pricing"
          data-qa-id="footer_pricing"
        >
          Pricing
        </a>
      </li>
      <li>
        <a
          className="list1"
          href="https://support.evite.com/support/solutions/articles/72000576127-free-vs-premium-invitations"
          data-qa-id="footer_prem_v_free"
        >
          Premium vs. Free
        </a>
      </li>
    </ul>
  </div>
);
